import { render, staticRenderFns } from "./DateDummy.vue?vue&type=template&id=046fa319&"
import script from "./DateDummy.vue?vue&type=script&lang=js&"
export * from "./DateDummy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports